"use client"
import parse, { HTMLReactParserOptions } from "html-react-parser"

interface IShopifyComponentProps {
  htmlString: string
}

export default function ShopifyComponent({ htmlString }: IShopifyComponentProps) {
  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (domNode.type === "script") {
        let externalScript = domNode.attribs.src ? true : false
        const script = document.createElement("script")
        if (externalScript) {
          script.src = domNode.attribs.src
        } else {
          script.innerHTML = domNode.children[0].data
        }
        document.head.append(script)
      }
    }
  }
  return parse(htmlString, options)
}
